import { createContext } from 'react';
import { PackageDataSet } from '../summaryPackages';

type PricingExperienceContextType = PackageDataSet | [];

export const PricingExperienceContext = createContext<PricingExperienceContextType>([]);
export const PricingExperienceProvider = PricingExperienceContext.Provider;
